export const footerConfig = {
    sections: [
        {
            title: 'About Royal Gems',
            content: 'Mine to market traceability with +40 years of global service. Natural & ethical diamonds, certified options in GIA, AGS, HRD, IGI, EGL(USA).',
        },
        {
            title: 'Quick Links',
            links: [
                { label: 'Home', href: '/' },
                { label: 'Welcome', href: '/welcome' },
                { label: 'Atelier', href: '/atelier' },
                { label: 'Contact', href: '/contact' },
                { label: 'Login', href: '/login' },
            ],
        },
        {
            title: 'Legal',
            links: [
                { label: 'Privacy Policy', href: '/privacy-policy' },
                { label: 'Terms of Service', href: '/terms-of-service' },
                { label: 'Security', href: '/.well-known/security.txt', external: true },
            ],
        },
        {
            title: 'Contact - Cincinnati Office',
            contactInfo: {
                email: 'info@royalgemsusa.com',
                phone: '+1 (513) 381-0339',
                address: ['525 Vine Street', 'Cincinnati, Ohio 45202', 'United States'],
            },
        },
        {
            title: 'Other Offices',
            contactInfo: {
                phone: 'New York: +1 (212) 764-3302',
                address: ['Dallas: +1 (972) 697-7661', 'Austin: +1 (469) 993-8166'],
            },
        },
    ],
    socialLinks: [
        { name: 'WhatsApp', url: 'https://wa.me/15133810339' },
        { name: 'LinkedIn', url: '#' },
        { name: 'Instagram', url: '#' },
    ],
    copyright: {
        prefix: '©',
        company: 'Royal Gems, Inc.',
        suffix: 'All rights reserved.',
    },
};
